import { AgGridReact } from 'ag-grid-react';
import { Theme, themeQuartz } from "ag-grid-community";
import React, { useEffect, useMemo } from 'react';
import Loader from '../../../../components/loader';
import { titleCell } from '../../../../components/elements/function';
import { useDepreciationApi } from '../../../../store/api/hooks/depreciationApiHook';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { DATE_FORMAT } from '../../../../_common/constant';
import Currency from '../../../../components/currency';



interface Props {
    _ref: any
    hasPermission?: boolean;
}
const TaxDeprecation: React.FC<Props> = ({ _ref, hasPermission = true }) => {
    const myTheme = themeQuartz.withParams({
        headerBackgroundColor: `#F0F0F0`
    });
    const theme = useMemo<Theme | "legacy">(() => {
        return myTheme;
    }, []);
    const params: any = useParams();
    const [rowData, setRowData] = React.useState<any[] | null>([]);
    const depreciationAPI = useDepreciationApi();

    const columnDefs = [
        
        { headerName: 'Depreciation Date', field: 'deprciationDate', headerClass: 'bg-[#f0f0f0]', width: 190, 
            cellRenderer: (data: any) => data.value ? moment(data.value).format(DATE_FORMAT) : '--' },
        { headerName: 'Opening Balance', field: 'purchaseCost', headerClass: 'bg-[#f0f0f0] ag-right-aligned-header', width: 200, cellClass: 'ag-right-aligned-cell', 
            cellRenderer: (data: any) => <Currency currency="USD" value={data.value} /> },
        //{ headerName: 'MACRS Rate', field: 'depreciationRate', headerClass: 'bg-[#f0f0f0]', width: 300, cellClass: 'ag-right-aligned-cell', cellRenderer: (data: any) =><Currency currency="USD" value={data.value} /> },
        { headerName: 'Current Month Depreciation', field: 'depriciationAmount', headerClass: 'bg-[#f0f0f0] ag-right-aligned-header', width: 240, cellClass: 'ag-right-aligned-cell', 
            cellRenderer: (data: any) => <Currency currency="USD" value={data.value} /> },
        { headerName: 'Accumulated Depreciation', field: 'accmAmount', headerClass: 'bg-[#f0f0f0] ag-right-aligned-header', width: 240, cellClass: 'ag-right-aligned-cell', 
            cellRenderer: (data: any) => <Currency currency="USD" value={data.value} /> },
        { headerName: 'Book Value', field: 'bookValueEnd', headerClass: 'bg-[#f0f0f0] ag-right-aligned-header', minWidth: 160, flex: 1, cellClass: 'ag-right-aligned-cell', 
            cellRenderer: (data: any) => <Currency currency="USD" value={data.value} /> },
        { headerName: 'Depreciation Rate', field: 'depreciationRate', headerClass: 'bg-[#f0f0f0] ag-right-aligned-header', minWidth: 160, flex: 1, cellClass: 'ag-right-aligned-cell', 
            cellRenderer: (data: any) => data.value ? `${data.value}%` : '--' },
    ];

    const GetMCARSDepreciation = (assetID: any = params.id) => {
        const payload = {
            assetID: assetID,
        };
        depreciationAPI.GetMCARSDepreciation(
            payload,
            (data: any) => {
                setRowData(data.depreciationList);
            },
            (error: any) => { }
        );
    };

    useEffect(() => {
        if (params.id) {
            GetMCARSDepreciation(params.id);
        }
    }, [params]);
    useEffect(() => {
        if (_ref?.current) {
            _ref.current.reload = GetMCARSDepreciation
        }

    }, [_ref]);

    return (
        <div ref={_ref}>
            <div className="flex items-center justify-between h-[60px]">
                <h4 className="font-semibold text-[0.938rem]">Tax Depreciation</h4>
            </div>
            <div className={`mb-3 ag-theme-alpine overflow-auto ${!rowData || rowData.length === 0 || rowData.length <= 2 ? 'h-[150px]' : 'h-[303px]'}`}>
                <AgGridReact
                    theme={theme}
                    columnDefs={columnDefs}
                    rowData={rowData || []}
                    pagination={false}
                    domLayout="normal"
                    ensureDomOrder={true}
                    suppressHorizontalScroll={true}
                    loadingOverlayComponent={Loader}
                    noRowsOverlayComponent={() => (
                        <div className="flex items-center justify-center h-full">
                            <div className="text-center text-gray-500">
                                <div className="text-lg font-medium">No Data Found</div>
                            </div>
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

export default TaxDeprecation;